import { Factory } from 'rosie';
import '../conversation_item_factory';

Factory.define('ContentPlaceholder').attr('type', 'PLACEHOLDER');

Factory.define('ContentPlaceholderItem')
  .extend('ConversationItem')
  .attr('content', ['content'], content => Factory.attributes('ContentPlaceholder', content));
